module.exports = __webpack_public_path__ + "static/media/arrow-right.1f6dda31.svg";